<template>
  <div class="container-fluid overflow-auto page-container-h">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data"></bread-crumb>

    <tables-page
      :tableData="data.table_data"
      :tableFields="data.table_fields"
      :pageData="data.page"
      v-on:result="getAdmin"
    >
      <template #cell(created_at)="row">
        {{ convertRocDate(row.item.created_at) }}
      </template>

      <template #cell(updated_at)="row">
        {{ convertRocDate(row.item.updated_at) }}
      </template>

      <template #cell(function)="row">
        <b-button
          variant="info"
          size="sm"
          v-auth="`update`"
          @click="openPermissionModal(row.item)"
        >
          更新權限
        </b-button>
      </template>
    </tables-page>

    <!-- 業務新增或編輯 modal -->
    <permission-edit-modal
      v-model="status.permissionEditModal"
      :data="data.temp_table_data"
      @sumit="updateAdmin" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import TablesPage from "@/components/layouts/TablesPage";
import baseApi from "@/models/API/baseApi";
import { convertRocDate } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';
import PermissionEditModal from"./components/modal/PermissionEditModal";

export default {
  name: 'permissionSettings',
  components: {
    BreadCrumb,
    TablesPage,
    datePicker,
    PermissionEditModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '設定', url: '', isActive: true },
          { name: '權限設定', url: '', isActive: false }
        ]
      },
      status: {
        permissionEditModal: false
      },
      data: {
        table_data: [],
        table_fields: [
          {
            key: "name",
            label: "姓名",
          },
          {
            key: "created_at",
            label: "創建時間"
          },
          {
            key: "updated_at",
            label: "變動時間"
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        page: {},
        temp_table_data: {}
      }
    }
  },
  mounted() {
    this.baseApi = new baseApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.data.page = Object.assign({}, this.baseApi.page);
      this.getAdmin();
    },
    convertRocDate,
    // 查詢帳號權限
    getAdmin(pageIndex = null) {
      const params = {
        'PageSize': this.data.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.data.page.pageIndex,
      };
      this.baseApi.getAdmin((response) => {
        const res = response.data;

        this.data.page.totalCount = res.total; // 總筆數
        this.data.table_data = res.data;
      }, params)
    },
    // 開啟權限編輯modal
    openPermissionModal(item = null) {
      this.status.permissionEditModal = true;

      this.data.temp_table_data = item;
    },
    // 更新帳號權限
    updateAdmin(data) {
      const params = {
        id: this.data.temp_table_data.id,
        permission: this.permissionParamsHandler(data)
      }

      this.baseApi.updateAdmin((response) => {
        const res = response.data;
        let result = '';

        if (res.code === 0) {
          result = { message: '更新成功', title: '權限設定' };

          this.status.permissionEditModal = false;
          this.getAdmin();
        }

        this.baseApi.toast(() => {}, result, res.code === 0);
      }, params)
    },
    // 權限參數處理
    permissionParamsHandler(data) {
      let permission = {};

      for (const [key, value] of Object.entries(data)) {
        permission = {
          ...permission,
          [key]: JSON.stringify(value)
        }
      }

      return permission;
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/permissionSettings.vue